import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api'

export const USERS_REQUEST = 'USERS_REQUEST'
export const USERS_SUCCESS = 'USERS_SUCCESS'
export const USERS_FAILURE = 'USERS_FAILURE'

export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_FAILURE = "USER_FAILURE";

export const USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_FAILURE = "USER_UPDATE_FAILURE";

export const USERS_TYPEAHEAD_REQUEST = "USERS_TYPEAHEAD_REQUEST";
export const USERS_TYPEAHEAD_SUCCESS = "USERS_TYPEAHEAD_SUCCESS";
export const USERS_TYPEAHEAD_FAILURE = "USERS_TYPEAHEAD_FAILURE";

export const USER_ACTIVITY_REQUEST = "USER_ACTIVITY_REQUEST";
export const USER_ACTIVITY_SUCCESS = "USER_ACTIVITY_SUCCESS";
export const USER_ACTIVITY_FAILURE = "USER_ACTIVITY_FAILURE";

export const USERS_DOWNLOAD_REQUEST = 'USERS_DOWNLOAD_REQUEST'
export const USERS_DOWNLOAD_SUCCESS = 'USERS_DOWNLOAD_SUCCESS'
export const USERS_DOWNLOAD_FAILURE = 'USERS_DOWNLOAD_FAILURE'

export function requestUsers(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users/search?${query}`,
      method: 'GET',
      types: ['USERS_REQUEST', 'USERS_SUCCESS', 'USERS_FAILURE']
    }
  }
}

export function requestUsersDownload(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users/search/download?${query}`,
      method: 'GET',
      types: ['USERS_DOWNLOAD_REQUEST', 'USERS_DOWNLOAD_SUCCESS', 'USERS_DOWNLOAD_FAILURE']
    }
  }
}

export function requestUser(id) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users/${id}`,
      method: 'GET',
      types: ["USER_REQUEST", "USER_SUCCESS", "USER_FAILURE"]
    }
  }
}

export function createUser(user) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users`,
      method: 'POST',
      body: JSON.stringify(user),
      types: ["USER_CREATE_REQUEST", "USER_CREATE_SUCCESS", "USER_CREATE_FAILURE"]
    }
  }
}

export function updateUser(user) {
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users/${user.id}`,
      method: 'PUT',
      body: JSON.stringify(user),
      types: ["USER_UPDATE_REQUEST", "USER_UPDATE_SUCCESS", "USER_UPDATE_FAILURE"]
    }
  }
}


export function requestUsersTypeahead(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/users/search?${query}`,
      method: 'GET',
      types: ['USERS_TYPEAHEAD_REQUEST', 'USERS_TYPEAHEAD_SUCCESS', 'USERS_TYPEAHEAD_FAILURE']
    }
  }
}

export function submitNPSForm(userID, vals) {
  return {
    [RSAA]: {
      // /api/catalog/users/0CA07F49-C2F4-4398-9785-828E3A642DFC/score
      endpoint: `${TELEMETRY_API}catalog/users/${userID}/score`,
      method: 'POST',
      body: JSON.stringify(vals),
      types: ['USERS_TYPEAHEAD_REQUEST', 'USERS_TYPEAHEAD_SUCCESS', 'USERS_TYPEAHEAD_FAILURE']
    }
  }
}

export function requestUserActivityAudits(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}catalog/user-activity-audit/search?${query}`,
      method: 'GET',
      types: ['USER_ACTIVITY_REQUEST', 'USER_ACTIVITY_SUCCESS', 'USER_ACTIVITY_FAILURE']
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/users/UsersActions.js